import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FinalitiesService {

  constructor(private readonly http: HttpClient) { }

  get() {
    return this.http.get<ResponseObjectModel<FinalitiesDto[]>>(`${environment.API_BASE_URL}/v1/Finalities`);
  }

  getByPersonType(personType: string, rType?: string) {
    return this.http.get<ResponseObjectModel<FinalitiesDto[]>>(`${environment.API_BASE_URL}/v1/Finalities?personType=${personType}&remmitanceType=${rType}`);
  }

}
